import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { firstValueFrom, from, Subject, takeUntil } from 'rxjs';

export const closeUri$: Subject<void> = new Subject();

export async function openUri(uri: string): Promise<void> {
  switch (Capacitor.getPlatform()) {
    case 'web':
      console.log('openUri', uri);
      return await Browser.open({ url: uri.toString(), windowName: '_self' });
    case 'ios':
      return await Browser.open({ url: uri.toString() });
    case 'android':
      return firstValueFrom(
        from(Browser.open({ url: uri.toString() })).pipe(takeUntil(closeUri$)),
      );
  }
}
